import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { zeusLogoWhite } from 'src/component/util/image'
import styles from 'src/screen/login-screen/login-screen.module.scss'


export const LoginBannerApollo = (): React.ReactElement => {
  return (
    <Container className={`ms-0 me-0 pt-5 ${styles.imgBackApollo}`}>
      
      
      <Row className="px-lg-1 py-3 pt-5">
        <Col lg={1}></Col>
        <Col lg={10} className="p-0">
          <p className="color-white fs-4">
            <h3 >
            <b className="font-20">
            ATOM 2.0 is Apollo Tyres end to end
              <br /> integrated logistics planning and <br />
              execution tool globally.
            </b>
            </h3>
          </p>
        </Col>
        <Col lg={1}></Col>
      </Row>
      <Row className="px-lg-1 py-3">
        <Col lg={1}></Col>
        <Col lg={10} className="p-0">
          <p className="color-white fs-4">
            <p className="font-20">
            This tool is designed to automate, simplify
              <br />
              and optimize core tasks, while also provides
              <br/>
              end-to-end real-time visibility and control
              <br/>
              over its transport operations.
            </p>
          </p>
        </Col>
        <Col lg={1}></Col>
      </Row>
      <Row className="px-lg-1 pt-5 pb-5">
      </Row>
      <Row className="px-lg-1 pt-5 pb-5">
      </Row>
      <Row className="px-lg-1 pt-5 pb-5">
      </Row>
      <Row className="px-lg-1 pt-5">
        <Col lg={1}></Col>
        <Col lg={10} className="p-0">
          <h1>
            <img src={zeusLogoWhite} />
          </h1>
        </Col>
        <Col lg={1}></Col>
      </Row>
    </Container>
  )
}
